"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsReadOnlySuspended = exports.getIsReadOnly = exports.getReadOnlyReason = void 0;

var _reselect = require("reselect");

var ReadOnlyReason = _interopRequireWildcard(require("../enums/ReadOnlyReason"));

var _Auth = require("./Auth");

var _Suspension = require("./Suspension");

var _Constants = require("../Constants");

var getReadOnlyReason = (0, _reselect.createSelector)([_Suspension.getSuspensionFetchStatus, _Suspension.getIsPortalSuspended, _Auth.getHasFileManagerWriteScope], function (fetchStatus, isSuspended, hasWriteScope) {
  if (!hasWriteScope) {
    if (fetchStatus === _Constants.RequestStatus.SUCCEEDED && isSuspended) {
      return ReadOnlyReason.PORTAL_SUSPENDED;
    }

    return ReadOnlyReason.USER_WRITE_PERMISSION;
  }

  return null;
});
exports.getReadOnlyReason = getReadOnlyReason;
var getIsReadOnly = (0, _reselect.createSelector)([getReadOnlyReason], function (readOnlyReason) {
  return Boolean(readOnlyReason);
});
exports.getIsReadOnly = getIsReadOnly;
var getIsReadOnlySuspended = (0, _reselect.createSelector)([getReadOnlyReason], function (readOnlyReason) {
  return readOnlyReason === ReadOnlyReason.PORTAL_SUSPENDED;
});
exports.getIsReadOnlySuspended = getIsReadOnlySuspended;